import {
  type UseMutationOptions,
  type UseMutationResult,
  useMutation,
} from '@tanstack/react-query';

import api from 'src/axios';

type AddProductsToSessionVariables = {
  sessionId: string;
  skus: string[];
};

type AddProductsToOpenSessionVariables = {
  skus: string[];
};

export const useAddProductsToSession = (
  options?: Omit<
    UseMutationOptions<void, Error, AddProductsToSessionVariables>,
    'mutationFn'
  >,
): UseMutationResult<void, Error, AddProductsToSessionVariables> => {
  return useMutation({
    mutationFn: async ({ sessionId, skus }: AddProductsToSessionVariables) => {
      const { data } = await api.post(
        `/sales-forecasting-sessions/${sessionId}/products`,
        { skus },
      );
      return data;
    },
    ...options,
  });
};

export const useAddProductsToOpenSession = (
  options?: Omit<
    UseMutationOptions<void, Error, AddProductsToOpenSessionVariables>,
    'mutationFn'
  >,
): UseMutationResult<void, Error, AddProductsToOpenSessionVariables> => {
  return useMutation({
    mutationFn: async ({ skus }: AddProductsToOpenSessionVariables) => {
      const { data } = await api.post(
        '/sales-forecasting-session/open/products',
        {
          skus,
        },
      );
      return data;
    },
    ...options,
  });
};
